// extracted by mini-css-extract-plugin
export default {"title":"_404_title__zdDrh","actions":"_404_actions__QYgw3"};